"use client";

import Image from "next/image";
import OrganisationCategories from "./org-categories";
import Skeleton from "react-loading-skeleton";
import Pagination from "../common/Pagination";
import styles from "./index.module.css";
import { useState } from "react";
import { useModalManager } from "../modal/useModalManager";
import FloatingHelper from "../store/floating-helper";

const OrgList = ({
  handleSwitch,
  state,
  openPage,
  token,
  isLoading,
  isFetching,
  currentAcc = null,
}) => {
  const [imageLoadedMap, setImageLoadedMap] = useState({});
  const handleImageLoad = (accessPointId) => {
    setImageLoadedMap((prev) => ({ ...prev, [accessPointId]: true }));
  };

  const currentAccessPointId = currentAcc
    ? (currentAcc.accessPointId ?? currentAcc)
    : null;

  const visibleAccessPoints = (state.accessPoints || []).filter(
    (acc) => acc.accessPointId !== currentAccessPointId,
  );

  const { modal } = useModalManager();
  const [isShowingFloater, setIsShowingFloater] = useState(false);

  return (
    <>
      <div className={styles.marketPlaceOrganisations}>
        {visibleAccessPoints.map((acc) => {
          const isLoaded = imageLoadedMap[acc.accessPointId];
          return (
            <div
              key={acc.accessPointId}
              className={styles.organisation}
              onClick={() => handleSwitch(acc)}
            >
              <div className={styles.organisationInfo}>
                {!acc.orgDetails?.logoUrl && (
                  <div className={styles.organisationPlaceholderLogo}>
                    {acc.orgDetails?.orgName?.[0]?.toUpperCase() || "?"}
                  </div>
                )}
                {acc.orgDetails?.logoUrl && (
                  <div>
                    {!isLoaded && <Skeleton width={70} height={70} circle />}
                    {isLoaded && (
                      <Image
                        src={acc.orgDetails?.logoUrl}
                        alt={`${acc.orgDetails?.orgName} logo`}
                        width={70}
                        height={70}
                        className={styles.organisationLogo}
                        style={{
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    )}
                    <img
                      src={acc.orgDetails?.logoUrl}
                      alt={acc.orgDetails?.orgName}
                      style={{ display: "none" }}
                      onLoad={() => handleImageLoad(acc.accessPointId)}
                    />
                  </div>
                )}
                <div className={styles.textInfo}>
                  {/* <p className={styles.organisationName}>
                    {acc.orgDetails?.orgName
                      .split(" ")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase(),
                      )
                      .join(" ")}
                  </p> */}
                  <p className={styles.organisationName}>
                    {[
                      acc.orgDetails?.orgName
                        ?.split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase(),
                        )
                        .join(" "),
                      acc.name,
                    ]
                      .filter(Boolean)
                      .join(" - ")}
                  </p>
                  <div className={styles.infoDiv}>
                    <p className={styles.organisationDescription}>
                      {acc.orgDetails?.description ||
                        "No description available."}
                    </p>
                    <p className={styles.organisationAddress}>
                      Address:{" "}
                      {acc.address ||
                        acc.ordDetails?.address ||
                        "No address available."}
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.organisationCategories}>
                <OrganisationCategories
                  acc={acc}
                  token={token}
                  handleSwitch={handleSwitch}
                />
              </div>
            </div>
          );
        })}
      </div>
      <Pagination
        infiniteScroll={true}
        total={state.total}
        limit={state.limit}
        page={state.page}
        onPageClick={openPage}
        enableManualMode={true}
        autoLoadThreshold={5}
        isLoading={isLoading}
        isFetching={isFetching}
        showEndOfList={true}
        endOfListText="🎉 You've reached the end!"
      />

      <FloatingHelper modal={modal} setIsShowingFloater={setIsShowingFloater} />
    </>
  );
};
export default OrgList;
